import Vue from "vue";
import Vuex from "vuex";

import {
  getMenu,
} from "@/request/apiLg";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isBigScreen: false,
    isProjectOverview: localStorage.getItem('isProjectOverview')
    ? localStorage.getItem('isProjectOverview')
    : 'false',
    currentProjectId: "",
    currentProjectName: "",
    projectArray: [],
    insatnceArr: [],
    insatnceArr2: [],
    alarmQuery: {},

    // elecuse:[],
    // wateruse:[],
    // airuse:[],
    // heatuse:[],
    // allElecP:'',
    // menu: JSON.parse(window.localStorage.getItem('MENU')) || [],
  },
  mutations: {
    mutationsSetAlarmQuery(state, value) {
      return (state.alarmQuery = value);
    },
    mutationsGetInstance(state, value) {
      return (state.insatnceArr = value);
    },
    mutationsGetInstance2(state, value) {
      return (state.insatnceArr2 = value);
    },
    mutationsShowBig(state) {
      return (state.isBigScreen = true);
    },
    mutationsShowProject(state) {
      localStorage.setItem('isProjectOverview', 'true')
      return (state.isProjectOverview = 'true');
    },
    mutationsHideProject(state) {
      localStorage.setItem('isProjectOverview', 'false')
      return (state.isProjectOverview = 'false');
    },
    mutationsHideBig(state) {
      return (state.isBigScreen = false);
    },
    mutationsChangeId(state, value) {
      // debugger
      window.localStorage.setItem("PROJECTID", JSON.stringify(value));
      state.currentProjectId = value;
      console.log("state.currentProjectName", state.currentProjectName);
      return;
    },
    mutationsChangeName(state, value) {
      window.localStorage.setItem("PROJECTNAME", JSON.stringify(value));
      state.currentProjectName = value;
      console.log("state.currentProjectName", state.currentProjectName);
      return;
    },
    mutationsChangeArray(state, value) {
      window.localStorage.setItem("PROJECTARRAY", JSON.stringify(value));
      state.projectArray = value;
      return;
    },
  },
  actions: {
    getMenus() {
      return new Promise((resolve) => {
        getMenu().then(res=>{
          window.localStorage.setItem("MENU", JSON.stringify(res.data.data));
          resolve(true)
        })
      })
    }
  },
  modules: {},
});
